export const GET = "GET_COMPANY"